import React from 'react';
import { block } from '../utils/cn';
import { CopyToClipboard, CopyToClipboardStatus } from '../CopyToClipboard';
import { ClipboardIcon } from '../ClipboardIcon';
import { Icon } from '../Icon';
import { CrossIcon } from '../icons/CrossIcon';
import { Button } from '../Button';
import './Label.css';
const b = block('label');
export const Label = React.forwardRef(function Label(props, ref) {
    const { type = 'default', theme = 'normal', size = 's', style = 'default', icon, children, onClose, className, disabled, copyText, closeButtonLabel, interactive = false, onCopy, onClick, } = props;
    const typeDefault = type === 'default';
    const typeClose = type === 'close';
    const typeCopy = type === 'copy';
    // Handle click for `default` type labels
    const hasOnClick = Boolean(onClick) && typeDefault;
    const isInteractive = hasOnClick || interactive;
    const hasAction = typeClose || typeCopy;
    let copyIconSize;
    let closeIconSize;
    switch (size) {
        case 's':
            copyIconSize = 12;
            closeIconSize = 8;
            break;
        case 'm':
        default:
            copyIconSize = 16;
            closeIconSize = 10;
            break;
    }
    const leftIcon = icon && React.createElement("div", { className: b('icon', { left: true }) }, icon);
    const content = React.createElement("div", { className: b('text') }, children);
    const renderCopyButton = (status) => {
        return (typeCopy && (React.createElement("div", { className: b('icon', { right: true, copy: true }) },
            React.createElement(ClipboardIcon, { status: status || CopyToClipboardStatus.Pending, size: copyIconSize }))));
    };
    const closeButton = typeClose && (React.createElement(Button, { onClick: onClose, pin: 'brick-round', size: size, extraProps: { 'aria-label': closeButtonLabel || undefined }, className: b('icon', {
            right: true,
            cross: true,
        }) },
        React.createElement(Icon, { size: closeIconSize, data: CrossIcon })));
    const renderLabel = (status) => {
        return (React.createElement("div", { ref: ref, onClick: hasOnClick ? onClick : undefined, className: b({
                // only default labels could have actions
                theme: hasAction ? 'normal' : theme,
                size,
                style,
                type,
                'is-interactive': isInteractive,
                'has-right-icon': hasAction,
                'has-left-icon': Boolean(icon),
                disabled,
            }, className) },
            leftIcon,
            content,
            renderCopyButton(status),
            closeButton));
    };
    const handleCopyClick = (event) => {
        /* preventing event from bubbling */
        event.stopPropagation();
    };
    const labelWithCopy = typeCopy && copyText && !disabled ? (React.createElement("div", { onClick: handleCopyClick },
        React.createElement(CopyToClipboard, { text: copyText, onCopy: onCopy, timeout: 1000 }, (status) => renderLabel(status)))) : (renderLabel());
    return labelWithCopy;
});
